"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fileToBase64 = exports.default = exports.ImageLibraryClient = void 0;

require("core-js/modules/es.promise.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.split.js");

require("core-js/modules/es.object.assign.js");

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

const fileToBase64 = async file => {
  const dataUrl = await fileToDataUrl(file);
  return stripDataUrlPrefix(dataUrl);
};

exports.fileToBase64 = fileToBase64;

const fileToDataUrl = file => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);

  reader.onload = () => resolve(reader.result);

  reader.onerror = error => reject(error);
}); // need to split resulting b64 string -
// cause go won't eat it...
// result is  "image/jpeg;base64,/9j/4AAQSkZJRg...
// but needed without prefix "image/jpeg;base64,"


const stripDataUrlPrefix = dataUrl => {
  let arr = dataUrl.split(",");

  if (arr.length > 1) {
    return arr[1];
  } else {
    throw new Error("Invalid DataUrl, cannot strip prefix");
  }
};

const imagesUrl = '/api/images';
const scopesUrl = '/api/scopes';

class ImageLibraryClient {
  constructor(host, token, scope) {
    _defineProperty(this, "hasScope", () => {
      return !!this.scope;
    });

    _defineProperty(this, "makeImagesUrl", () => {
      if (this.hasScope()) {
        return this.host + imagesUrl + "?scope=".concat(this.scope);
      } else {
        return this.host + imagesUrl;
      }
    });

    _defineProperty(this, "getScopesUrl", () => {
      return this.host + scopesUrl;
    });

    _defineProperty(this, "destroyImageUrl", id => {
      return this.host + imagesUrl + "/" + id;
    });

    _defineProperty(this, "updateImageUrl", id => {
      return this.host + imagesUrl + "/" + id;
    });

    _defineProperty(this, "getScopes", async () => {
      let res = await fetch(this.getScopesUrl(), {
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
        mode: 'cors'
      });

      try {
        let scopeStats = await res.json();

        if (res.ok) {
          return scopeStats;
        } else {
          throw new Error('Api Error: ', JSON.stringify(scopeStats));
        }
      } catch (e) {
        console.error(e.message);
        throw new Error('content kein json: ' + e.message);
      }
    });

    _defineProperty(this, "getImages", async () => {
      let res = await fetch(this.makeImagesUrl(), {
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
        mode: 'cors'
      });

      try {
        let images = await res.json();

        if (res.ok) {
          return images;
        } else {
          throw new Error('Api Error: ' + JSON.stringify(images));
        }
      } catch (e) {
        throw new Error('content kein json: ' + e.message);
      }
    });

    _defineProperty(this, "createImage", async values => {
      Object.assign(values, {
        scope: this.scope
      });
      let payload = JSON.stringify(values);
      console.log("payload: ", payload);
      let res = await fetch(this.makeImagesUrl(), {
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
        method: 'POST',
        mode: 'cors',
        body: payload
      });

      try {
        let image = await res.json();

        if (res.ok) {
          return image;
        } else {
          throw new Error('Api Error: ' + JSON.stringify(image));
        }
      } catch (e) {
        throw new Error('content kein json: ' + e.message);
      }
    });

    _defineProperty(this, "updateImage", async (id, values) => {
      let res = await fetch(this.updateImageUrl(id), {
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
        method: 'PATCH',
        mode: 'cors',
        body: JSON.stringify(values)
      });

      try {
        let image = await res.json();

        if (res.ok) {
          return image;
        } else {
          throw new Error('Api Error: ' + JSON.stringify(image));
        }
      } catch (e) {
        throw new Error('content kein json: ' + e.message);
      }
    });

    _defineProperty(this, "destroyImage", async id => {
      const url = this.destroyImageUrl(id);
      let res = await fetch(url, {
        headers: {
          'Authorization': 'Bearer ' + this.token
        },
        method: 'DELETE',
        mode: 'cors'
      });

      if (res.status === 204) {
        return true;
      } else {
        console.error("RES: ", res);
        throw new Error('Api Error: could not delete image ' + id);
      }
    });

    this.host = host;
    this.scope = scope;
    this.token = token;
  }

}

exports.ImageLibraryClient = ImageLibraryClient;
var _default = ImageLibraryClient;
exports.default = _default;